// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"756":"69ec9a76","787":"e0394e26"}[chunkId] + ".chunk.js";
};